import { gql } from "@apollo/client";

export const CREATE_OPTION_VALUE = gql`
  mutation CreateOptionValue($data: OptionValueInput!) {
    createOptionValue(data: $data) {
        id
    }
}
`;

export const UPDATE_OPTION_VALUE = gql`
  mutation UpdateOptionValue($data: OptionValueInput!,$where: OptionValueWhereInputOne!) {
    updateOptionValue(where: $where, data:$data) {
        id
    }
}
`;

export const DELETE_OPTION_VALUE = gql`
  mutation DeleteOptionValue($where: OptionValueWhereInputOne!) {
    deleteOptionValue(where: $where) {
        id
    }
}
`;